import { FormControl, Grid, InputLabel } from '@mui/material';
import { parseMaterialPatternString, toPatternString } from 'Pattern';
import { BoardType, Material, ParamsPanelProps } from 'Types';

import MaterialPatternInput from 'designer/MaterialPatternInput';
import MaterialSelector from 'designer/MaterialSelector';
import NumberInput from 'designer/NumberInput';

function WeaveParamsPanel(props: ParamsPanelProps<BoardType.Weave>) {
  const { params, selection, onParamChange, onSelectionChange, units } = props;
  const { background } = params;
  const backgroundPattern = parseMaterialPatternString(background);
  const backgroundSize = +backgroundPattern[0]?.size ?? 0;
  const backgroundMaterial = (backgroundPattern[0]?.key ??
    Material.M) as Material;

  const onBackgroundMaterialChange = (material: Material) => {
    const newBackground = toPatternString([
      {
        size: backgroundSize,
        key: material,
        flip: false,
      },
    ]);
    onParamChange('background')(newBackground);
  };

  const onBackgroundSizeChange = (size: number) => {
    const newBackground = toPatternString([
      {
        size,
        key: backgroundMaterial,
        flip: false,
      },
    ]);
    onParamChange('background')(newBackground);
  };

  return (
    <Grid container direction="column" spacing={4}>
      <Grid container item spacing={2} wrap="nowrap">
        <Grid item xs={4}>
          <NumberInput
            id="horizontal-size"
            label="Horizontal Size"
            min={1}
            value={params.horizontalSize}
            onChange={onParamChange('horizontalSize')}
          />
        </Grid>
        <Grid item xs={4}>
          <NumberInput
            id="vertical-size"
            min={1}
            label="Vertical Size"
            value={params.verticalSize}
            onChange={onParamChange('verticalSize')}
          />
        </Grid>
        <Grid item xs={4}>
          <NumberInput
            id="thickness"
            label="Thickness"
            step={1 / 8}
            value={params.thickness}
            onChange={onParamChange('thickness')}
          />
        </Grid>
      </Grid>

      <Grid item>
        <MaterialPatternInput
          id="pattern"
          onChange={onParamChange('pattern')}
          onSelectionChange={onSelectionChange}
          previewHeight={1}
          selection={selection}
          units={units}
          value={params.pattern}
        ></MaterialPatternInput>
      </Grid>

      <Grid container item spacing={2} wrap="nowrap">
        <Grid item xs={4}>
          <NumberInput
            id="background-size"
            label="Background Size"
            step={1 / 8}
            value={backgroundSize}
            onChange={onBackgroundSizeChange}
          />
        </Grid>

        <Grid item>
          <FormControl variant="standard">
            <InputLabel>Background</InputLabel>
            <MaterialSelector
              onChange={onBackgroundMaterialChange}
              value={backgroundMaterial}
            />
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default WeaveParamsPanel;
